/* eslint-disable prettier/prettier */
import { MyThunkResult } from 'store';

import { countriesAutoCompleteSuccessful, countriesAutoCompleteError, countriesAutoCompleteRequest } from 'action-creators/countriesAutocomplete';
import { CountryAutoCompleteRequestResponse } from 'models/countryAutoComplete';
import { getCurrentLanguage } from 'utils/generic';
import { getLanguageWithoutRegion } from 'utils/i18n';

import { axiosConfig, netaticaCountries } from '../api';

export const searchCountriesAutocomplete =
  (text: string): MyThunkResult<Promise<void>> =>
  async (dispatch, getState) => {
    try {
      dispatch(countriesAutoCompleteRequest());
      const { country } = getState().i18n;
      const currentLanguage = country ? getLanguageWithoutRegion(getCurrentLanguage()) : 'ES';

      const { data } = await netaticaCountries.get<CountryAutoCompleteRequestResponse>('', {
        params: {
          text: text.sanitizeExceptAccents(),
          language: currentLanguage.toUpperCase()
        },
        ...axiosConfig,
      });

      dispatch(countriesAutoCompleteSuccessful(data.data));
    } catch (ex) {
      dispatch(countriesAutoCompleteError(ex));
    }
  };
